import { FETCH_PROPERTIES, MOVE_PROPERTY, UPDATE_GEOMETRY_PROPERTY } from 'actions/properties';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_PROPERTIES:
			return action.payload;
		case MOVE_PROPERTY: {
			let newState = { ...state };
			if (action.payload.id && action.payload.position) {
				newState.aggregations.geo.buckets = newState.aggregations.geo.buckets.map(bucket => {
					const hits = bucket.items.hits.hits.map(p => {
						if (p._source.id === action.payload.id) {
							return { ...p, _source: { ...p._source, lat: action.payload.position.lat, lng: action.payload.position.lng }};
						}
						return p;
					})
					let newBucket = bucket;
					newBucket.items.hits.hits = hits;
					return newBucket;
				})
			}
			return newState;
		}
		case UPDATE_GEOMETRY_PROPERTY: {
			let newState = { ...state };
			if (action.payload.id && action.payload.geometry) {
				newState.aggregations.geo.buckets = newState.aggregations.geo.buckets.map(bucket => {
					const hits = bucket.items.hits.hits.map(p => {
						if (p._source.id === action.payload.id) {
							return { ...p, _source: { ...p._source, geometry: action.payload.geometry }};
						}
						return p;
					})
					let newBucket = bucket;
					newBucket.items.hits.hits = hits;
					return newBucket;
				})
			}
			return newState;
		}
		default:
			return state;
	}
};